import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val vyapar = true
    onWasmReady {
        CanvasBasedWindow(canvasElementId = "ComposeTarget") {
            if (vyapar) AppV() else App()
            //AppText()
        }
    }
}